import fossilImg1 from '@/assets/img/content6/category1/fossilImg1.jpg'
import fossilImg2 from '@/assets/img/content6/category1/fossilImg2.jpg'
import fossilImg3 from '@/assets/img/content6/category1/fossilImg3.jpg'
// import fossilImg4 from '@/assets/img/content6/category1/fossilImg4.jpg'
// import fossilImg5 from '@/assets/img/content6/category1/fossilImg5.jpg'
import fossilImg6 from '@/assets/img/content6/category1/fossilImg6.jpg'


import fossil2Img1 from '@/assets/img/content6/category2/fossil2Img1.jpg'
import fossil2Img2 from '@/assets/img/content6/category2/fossil2Img2.jpg'
import fossil2Img3 from '@/assets/img/content6/category2/fossil2Img3.jpg'

export const btnList = [
  {
    id: 1,
    cnTitle: '孔子鸟',
    enTitle: '<em>Confuciusornis</em>',
  },
  {
    id: 2,
    cnTitle: '会鸟科',
    enTitle: 'Sapeornithidae',
  },
]

export const confuciusornisShowList = [ // 孔子鸟展示化石
  {
    id: 1,
    src: fossilImg3,
    title: '化石：孔子鸟未定种',
    enTitle: '<em>Confuciusornis</em> sp.',
    details: '',
  },
  // {
  //   id: 2,
  //   src: fossilImg4,
  //   title: '化石：孔子鸟科',
  //   enTitle: 'Confuciusornidae',
  //   details: '',
  // },
  // {
  //   id: 3,
  //   src: fossilImg5,
  //   title: '化石：孔子鸟科',
  //   enTitle: 'Confuciusornidae',
  //   details: '',
  // },
  {
    id: 6,
    src: fossilImg6,
    title: '化石：孔子鸟科',
    enTitle: 'Confuciusornidae',
    details: '',
  },
  {
    id: 4,
    src: fossilImg1,
    title: '现代鸟：葵花凤头鹦鹉',
    enTitle: '<em>Cacatua galerita</em>（Latham，1790）',
    details: '',
  },
  {
    id: 5,
    src: fossilImg2,
    title: '现代鸟：红绿金刚鹦鹉',
    enTitle: '<em>Ara chloropterus</em>（G.R. Gray，1859）',
    details: '',
  },
]

export const confuciusornisAnimal = { // 孔子鸟
  animalType: '孔子鸟', // 动物类别
  animalTypeEn: '<em>Confuciusornis</em>', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '<p>孔子鸟是热河生物群最富盛名的鸟类化石，也是迄今为止发现的最早具有角质喙而没有牙齿的鸟类。迄今为止，热河生物群中出土了数千件孔子鸟化石，有些标本不但保存了完整的骨骼，而且还保存有精美的羽毛印痕，几乎可以与德国的始祖鸟和现代鸟类的羽毛相媲美。孔子鸟还具有性双型现象：雄鸟具有缎带一样的长尾羽，而雌鸟无。性双型现象在现生鸟类中也可以看到。</p><p>孔子鸟也是已知最原始长有尾综骨的鸟类之一。其最鲜明的特征之一是强壮而无齿的上下颌，以及强有力、覆盖角质化外壳的喙嘴，很适合啄破坚硬的种子和果实，与现代的大型攀禽如鹦鹉等较为相似。其胸骨较大，翅膀较为窄长，大量羽毛覆盖在掌骨和翼尖，适合快速飞行。</p>', // 动物文字介绍
  showList: confuciusornisShowList,
}




export const sapeornithidaeList = [
  {
    id: 1,
    src: fossil2Img3,
    title: '化石：会鸟科',
    enTitle: '',
    details: '',
  },
  {
    id: 2,
    src: fossil2Img1,
    title: '现代鸟：高山兀鹫',
    enTitle: '<em>Gyps himalayensis</em> Hume, 1869',
    details: '',
  },
  {
    id: 3,
    src: fossil2Img2,
    title: '现代鸟：燕隼',
    enTitle: '<em>Falco subbuteo</em> Linnaeus, 1758',
    details: '',
  },
]

export const sapeornithidaeAnimal = { // 会鸟科
  animalType: '会鸟科', // 动物类别
  animalTypeEn: 'Sapeornithidae', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '会鸟是早白垩世最大的鸟类，头骨宽阔、颈部修长，腿部覆盖着羽毛，上颌有十几枚牙齿，下颌没有牙齿，可能已经被角质喙覆盖，它的翅膀上还保存了爪的构造，尾巴已经十分缩短，这一点特征已经和其他进步的鸟类非常相似。翼展可达一米多的宽大翅膀表明会鸟有着非常娴熟的滑翔技巧，就像现代的鹳和秃鹰。会鸟吃果实和种子，它们长而强壮的发达趾爪和肉垫与现代猛禽十分相似。', // 动物文字介绍
  showList: sapeornithidaeList,
}